import { createContext, useState } from "react";

/**
 * Modal context.
 */
export const AuthContextApi = createContext();

/**
 * Generates an authentication context provider component.
 * @param {ReactDOM.props} props Component properties.
 * @returns Generated component.
 */
const AuthProviderApi = (props) => {
  // Initialize states
  const [authUser, setAuthUser] = useState(null);
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [association, setAssociation] = useState(null);
  const [relation, setRelation] = useState(null);
  const [settings, setSettings] = useState(null);

  // Render component
  return (
    <AuthContextApi.Provider
      value={{
        utilisateur_identifie: authUser,
        utilisateur_reel: user,
        cabinet: company,
        groupement: association,
        relation: relation,
        preferences: settings,
      }}
    >
      {props.children}
    </AuthContextApi.Provider>
  );
};
export default AuthProviderApi;
